import { server } from "@/utils/client";
export interface SlotType {
    id: number;
    name: string;
    times: Time[];
    rollover: Rollover[];
}

export interface Time {
    end_time: number;
    start_time: number;
}
export interface Rollover {
    min: number;
    max: number;
    weight: number;
}

export const getGiveInfoApi = () => {
    return server.post<SlotType>({
        url: "/v1/api/user/give/info",
        data: {},
    });
};

/**
 * 领取免费送奖励
 *   POST /v1/api/user/give/receive
 *   接口ID：244962191
 *   接口地址：https://app.apifox.com/link/project/4790544/apis/api-244962191
 */
export interface SlotParams {
    /**
     * 领取ID
     */
    activity_id: number;
    end_time: number;
    start_time: number;
}
export interface GiveReceiveResponse {
    amount: number;
    currency: string;
    /**
     * 100=1倍
     */
    rollover: number;
}

export const getGiveReceiveApi = (data: SlotParams) => {
    return server.post<GiveReceiveResponse>({
        url: "/v1/api/user/give/receive",
        data,
    });
};
